import { Heading, Paragraph } from '@graftcode/design-system'

import { GLOSSARY_TEST_IDS } from '../../glossary.const'

import styles from './GlossaryHeader.module.scss'

export function GlossaryHeader() {
  return (
    <div className={styles.header} data-testid={GLOSSARY_TEST_IDS.header}>
      <Heading className={styles.title} type="h1">
        Glossary
      </Heading>
      <Paragraph className={styles.description}>
        A comprehensive list of key terms and concepts used across the Graftcode platform and documentation.
      </Paragraph>
    </div>
  )
}
